var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.Value !== null && _vm.Value !== undefined)?_c('b-icon',{staticClass:"w-100",attrs:{"icon":"circle-fill","variant":_vm.Value !== _vm.Header.TrueValue ? 'danger' : 'success'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }